export const openLiveChat = (traceId?: string) => {
  if (typeof window !== 'undefined' && window.Intercom) {
    if (traceId) {
      // eslint-disable-next-line new-cap
      window.Intercom('update', {
        custom_attributes: {
          trace_id: traceId,
        },
      });
    }
    // eslint-disable-next-line new-cap
    window?.Intercom('show');
    if (traceId) {
      // eslint-disable-next-line new-cap
      window?.Intercom('showNewMessage', `Hi! I encountered an error. Here’s my Trace ID: ${traceId}`);
    }
  }
};
